import { createAction } from '@reduxjs/toolkit'

export const fetchRuleSlugs = createAction('slugs/fetchRuleSlugs')
export const createRuleSlug = createAction('slugs/createRuleSlug')
export const updateRuleSlug = createAction('slugs/updateRuleSlug')
export const deleteRuleSlug = createAction('slugs/deleteRuleSlug')
